// 当vue作为SPA页面时，每个页面的pegetype不相同时，可以在router中配的meta中添加埋点初始化参数：
/**
 * {
 *   path:'/page1',
 *   conmpnent: page1,
 *   meta:{
 *      log:{
 *          pageType:'',
 *          params:''
 *      }
 *    }
    }
 */
import { isObject } from '../../helpers';

export default function (route: any): any {
    if (!route) {
        return {};
    }
    const meta = route.meta;
    if (meta?.log) {
        return isObject(meta.log) ? meta.log : {};
    }
    return {};
}
